import * as actionTypes from '../actions/actionTypes';

const intiData = {
  data: {
    formData: {
    availableAddresses:[],
    availableContacts:[]
   }
  },
  statuses: {
    specificDetails: {
      status: "incomplete"
    },
    addressAndContacts: {
      status: "incomplete"
    }
  }
};

export default function currentProductCorporateCardReducer(state = intiData, action) {
  switch(action.type){
    case actionTypes.SET_PRODUCT_CORPORATECARD: {
      let newState = {...state};
      newState.data = action.data;
      return newState;
    }

    case actionTypes.SET_CORPORATECARD_ACTIVE_TAB_INDEX:{
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }

    case actionTypes.RESET_CORPORATECARD_ACTIVE_TAB_INDEX:{
      let newState = {...state};
      newState.activeTabIndex =-1;
      return newState;
    }

    case actionTypes.RESET_CORPORATECARD_PRODUCT : {
      return intiData;
    }

    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/currentProductCorporateCardReducer.js